export class UserCredential {
  constructor(
    Usr_nute,
    Usr_pswd,
    Www_akey,
    Usr_psw1,
    Per_nome,
    Per_cogn,
    RegNewUser,
    Lin_codi,
    JwtToken,
    Usr_vkey,
    Per_priv,
    Usr_news,
    Usr_psw2,
    Usr_rmai,
    Rst_codi
  ) {
    if (Usr_nute != undefined && typeof Usr_nute == "string") {
      this.Usr_nute = Usr_nute;
    } else {
      this.Usr_nute = "";
    }

    if (Usr_pswd != undefined && typeof Usr_pswd == "string") {
      this.Usr_pswd = Usr_pswd;
    } else {
      this.Usr_pswd = "";
    }

    if (Www_akey != undefined && typeof Www_akey == "string") {
      this.Www_akey = Www_akey;
    } else {
      this.Www_akey = "";
    }

    if (Usr_psw1 != undefined && typeof Usr_psw1 == "string") {
      this.Usr_psw1 = Usr_psw1;
    } else {
      this.Usr_psw1 = "";
    }

    if (Per_nome != undefined && typeof Per_nome == "string") {
      this.Per_nome = Per_nome;
    } else {
      this.Per_nome = "";
    }

    if (Per_cogn != undefined && typeof Per_cogn == "string") {
      this.Per_cogn = Per_cogn;
    } else {
      this.Per_cogn = "";
    }

    if (RegNewUser != undefined && typeof RegNewUser == "boolean") {
      this.RegNewUser = RegNewUser;
    } else {
      this.RegNewUser = false;
    }

    if (Lin_codi != undefined && typeof Lin_codi == "number") {
      this.Lin_codi = Lin_codi;
    } else {
      this.Lin_codi = 96; //italiano
    }

    if (JwtToken != undefined && typeof JwtToken == "string") {
      this.JwtToken = JwtToken;
    } else {
      this.JwtToken = "";
    }

    //verifica utente e change password
    if (Usr_vkey != undefined && typeof Usr_vkey == "string") {
      this.Usr_vkey = Usr_vkey;
    } else {
      this.Usr_vkey = "";
    }

    if (Per_priv != undefined && typeof Per_priv == "boolean") {
      this.Per_priv = Per_priv;
    } else {
      this.Per_priv = false;
    }

    if (Usr_news != undefined && typeof Usr_news == "boolean") {
      this.Usr_news = Usr_news;
    } else {
      this.Usr_news = false;
    }

    if (Usr_psw2 != undefined && typeof Usr_psw2 == "string") {
      this.Usr_psw2 = Usr_psw2;
    } else {
      this.Usr_psw2 = "";
    }

    //mail per cambio password
    if (Usr_rmai != undefined && typeof Usr_rmai == "string") {
      this.Usr_rmai = Usr_rmai;
    } else {
      this.Usr_rmai = "";
    }

    //mail per cambio password
    if (Rst_codi != undefined && typeof Rst_codi == "string") {
      this.Rst_codi = Rst_codi;
    } else {
      this.Rst_codi = "";
    }
  }
}
